import { moduleFailed } from '../../utilities/_module_failure.js';
import(`./_loans.js`).then(module => module.init()).catch(moduleFailed('_loans.js'));
